import React from "react";
import { StyleguideDocument } from "tsi-common-react/src/styleguide/StyleguideDocument";

import { Context } from "@reactivated";

import { Template as SessionKeepAlive } from "../../templates/SessionKeepAliveTemplate";

type IProps = {
    storybook: boolean;
    children?: React.ReactNode;
};

/**
 * Toppers' styleguide document chrome, shared by the block and element
 * fixture templates. Mirrors the legacy _styleguide_base.html: the
 * .layout / #main-content wrappers and the keep-alive furniture (toppers has
 * no financing modal, zendesk widget, or extra font links).
 */
export const StyleguideChrome = (props: IProps): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    return (
        <StyleguideDocument
            storybook={props.storybook}
            htmlLang={chrome.html_lang}
            bodyId={chrome.body_id}
            legacyJsUrl={`${chrome.static_base}dist2/legacy.js`}
            bodyEnd={<SessionKeepAlive />}
        >
            {props.storybook ? (
                props.children
            ) : (
                <div className="layout">
                    <main id="main-content">{props.children}</main>
                </div>
            )}
        </StyleguideDocument>
    );
};
